import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookMaintenanceOperationalRestrictionTable extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          report_action: props.report_action,
          overload_analysis_str: '',
          correlation_analysis_str: '',
          limit_date_str: '',
          approval_date_str: '',
          status_str: '',
          overload_analysis: props.report_action.overload_analysis,
        };

        this.approve = this.approve.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      // LM

      approve() {
        this.props.approveDeferredItem(this.state.report_action.id, this.state.overload_analysis)
      }
    
      render() {
        var self = this;
        return (
        <tr className="text-center" key={this.state.report_action.id}>
            <td width="100">{this.state.report_action.item_number}</td>
            <td width="100">{this.state.report_action.mel}</td>
            <td width="100">{this.state.report_action.category}</td>
            <td width="100">{this.state.report_action.type_str}</td>
            <td width="100">{this.state.report_action.limit_type_str}</td>
            <td width="100">{this.state.report_action.limit}</td>
            <td width="100">{this.state.report_action.limit_date_str}</td>
            <td width="100">{this.state.report_action.limit_hour}</td>
            <td width="100">{this.state.report_action.limit_landing}</td>
            <td width="100">{this.state.report_action.description}</td>
            <td width="100">{this.state.report_action.reason}</td>
            <td width="100">{this.state.report_action.correlation_analysis_str}</td>
            {
                (this.state.report_action.status !== 0) ?
                    <td width="150">{this.state.report_action.overload_analysis_str}</td>
                :
                <td width="150">
                    <Select
                        className="form-group"
                        name="overload_analysis"
                        value={self.state.overload_analysis}
                        searchable={true}
                        placeholder={"Selecionar"}
                        onChange={self.handleSelectChange.bind(self, 'overload_analysis')}
                        options={[
                            {value: 0, label: "Recusado"},
                            {value: 1, label: "Ok"},
                        ]}
                        required
                    />
                </td>
            }
            <td width="100">{this.state.report_action.status_str}</td>
            <td width="100">{this.state.report_action.captain}</td>
            <td width="100">{this.state.report_action.captain_approval_date_str}</td>
            {
                (this.state.report_action.status !== 0) ?
                <td width="100">
                    <div>
                        <button className="btn btn-success btn-sm" disabled><i className="fa fa-check"></i></button>
                    </div>
                </td>
                :
                <td width="100">
                    <div>
                        <button onClick={self.approve} className="btn btn-success btn-sm"><i className="fa fa-check"></i></button>
                    </div>
                </td>
            }
        </tr>
    );
  }
}

export default AircraftLogbookMaintenanceOperationalRestrictionTable;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookMaintenanceOperationalRestrictionTable.js